import { render, staticRenderFns } from "./ArchivesItem.vue?vue&type=template&id=d27f74c4&scoped=true&"
import script from "./ArchivesItem.vue?vue&type=script&lang=ts&"
export * from "./ArchivesItem.vue?vue&type=script&lang=ts&"
import style0 from "./ArchivesItem.vue?vue&type=style&index=0&id=d27f74c4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d27f74c4",
  null
  
)

export default component.exports